export default __webpack_public_path__ + "static/pragicts-automation-services-configuration-management-e44fe094f6a3c37c977cf1cfe92c62cb.jpg";